import { useQuery } from '@tanstack/react-query';

import { apiClient } from '@services/apiClient';

export const locationsGetOneKey = (locationId) => ['locationsGetOneKey', locationId];
export const locationsGetOneFn = ({ queryKey }) =>
  apiClient.get(`${APP_API_URL}locations/get-one`, {
    params: { id: queryKey[1] },
  });

export const useLocationsGetOneQuery = ({ locationId }) => {
  return useQuery({
    queryKey: locationsGetOneKey(locationId),
    queryFn: locationsGetOneFn,
    enabled: !!locationId,
    select: ({ data }) => data?.model,
  });
};
